module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-Regular.f415bc85.woff2";